module.exports = __webpack_public_path__ + "static/pauseVid-0a1807c32a0ba219fad46d04255a10bd.mp4";